"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'shopAlarm',
  components: {
    drawer: _filter.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        page_num: 1,
        type: 2,
        limit: 20
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表数据
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/business/merchants_businessing_worns', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.equip_table.$el.offsetTop - 85;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 跳转至客服跟进记录详情
     */
    handleViewCustomerDetail: function handleViewCustomerDetail(row) {
      this.$router.push({
        name: 'customerRecord',
        query: {
          page_call_type: 'query',
          store_id: row.cs_store_id
        }
      });
    },
    /**
     * 跳转至创建客服跟进记录
     */
    handleCreateCustomerRecord: function handleCreateCustomerRecord(row) {
      this.$router.push({
        name: 'customerRecord',
        query: {
          page_call_type: 'create',
          store_id: row.store_id,
          store_name: row.store_name,
          phone: row.phone,
          name: row.name,
          business_des: row.business_des,
          aid: row.aid
        }
      });
    }
  }
};